import React, { FC, useState, useRef } from 'react'
import { IonContent, IonHeader, IonModal } from '@ionic/react'
import waiterImg from '@img/cashier/waiter.png'
import { checkoutMobx } from '@mobxStore'
import { storeMobx } from 'restaurant'
import './index.scss'

interface IProps {
  resolve?: any;
  reject?: any;
  isWaitForReceive?: boolean;
}

const WaiterModal: FC<IProps> = ({ resolve, reject, isWaitForReceive = true }) => {
  const [downTime, setDownTime] = useState(isWaitForReceive ? 5 : 2)
  let inter = useRef(null as any)

  return (
    <IonModal
      isOpen
      cssClass='waiter-modal center-modal'
      onDidPresent={() => {
        let count = isWaitForReceive ? 5 : 2
        inter.current = setInterval(() => {
          setDownTime(--count)
          if (count === 0) {
            resolve()
          }
        }, 1000)
      }}
      onWillDismiss={() => {
        clearInterval(inter.current)
      }}
    >
      <IonHeader>
        <h3>
          {/* {i18n.t('common.reminder')} */}
        </h3>
        <i
          className='iconfont icon-close' data-cypid='waiterModalClose' onClick={() => {
            resolve()
          }}
        >
        </i>
      </IonHeader>
      <IonContent>
        <div>
          {/* <img width={160} height={100} src={waiterImg} /> */}
          <i className='iconfont icon-zhifuwancheng'></i>
          {
            isWaitForReceive && (
              <>
                <h5>
                  {i18n.t('checkout.alreadyRecordYourOrder')}
                </h5>
                <h5>
                  {i18n.t('checkout.contactWaiterToOrder')}
                </h5>
                {
                  storeMobx.storeSceneConfig.memberConfirmOrders === 1 && (!checkoutMobx.isMemberLogin) && (
                    <a data-cypid='waiterModalConfirm' onClick={() => resolve(true)}>
                      {i18n.t('checkout.memberFastOrder')}
                    </a>
                  )
                }
              </>
            )
          }
          {
            !isWaitForReceive && (
              <>
                {/* <h5>
                  {i18n.t('checkout.waiterHasOrder')}
                </h5>
                <h5>
                  {i18n.t('checkout.pleaseCheckYourOrder')}
                </h5> */}
                <h5>{i18n.t('checkout.orderSuccess')}</h5>
              </>
            )
          }
          <small>{i18n.t('checkout.secondAndDisappear', { value: downTime })}</small>
        </div>
      </IonContent>
    </IonModal>
  )
}

export default WaiterModal
